import { render, staticRenderFns } from "./QaList.vue?vue&type=template&id=ead5507a"
import script from "./QaList.vue?vue&type=script&lang=js"
export * from "./QaList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports